<template>
  <div>

    <div v-if="home.label !== undefined" class="row">
      <div class="col-md-12">
        <div class="form-group">
          <fg-input type="text"
                    label="Nombre"
                    :disabled="!editable"
                    v-model="home.label">
          </fg-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <fg-input type="text"
                    label="Direccion"
                    :disabled="!editable"
                    v-model="home.address.address_line1">
          </fg-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <fg-input type="text"
                    label="Datos adicionales"
                    :disabled="!editable"
                    v-model="home.address.address_line2">
          </fg-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group">
        <div class="col-md-6">
          <fg-input type="text"
                    label="Ciudad"
                    :disabled="!editable"
                    v-model="home.address.city">
          </fg-input>
        </div>
        <div class="col-md-6">
          <fg-input type="text"
                    label="Provincia"
                    :disabled="!editable"
                    v-model="home.address.state">
          </fg-input>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group">
        <div class="col-md-6">
          <fg-input type="text"
                    label="País"
                    :disabled="!editable"
                    v-model="home.address.country">
          </fg-input>
        </div>
        <div class="col-md-6">
          <fg-input-validate type="text"
                              validations="numeric"
                              name="codigo postal"
                              label="Código Postal"
                              delay="0"
                              @input-changed="input_changed"
                              v-model="home.address.postal_code">
          </fg-input-validate>
          <!-- <fg-input type="text"
                    label="Código Postal"
                    :disabled="!editable"
                    v-model="home.address.postal_code">
          </fg-input> -->
        </div>
      </div>
    </div>

  </div>

</template>
<script>
  export default {
    props: {
      home: null,
      editable: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
      }
    },
    methods: {
      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.address))
      },
      input_changed (key, has_error) {
        this.$emit('input-changed', key, has_error)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// MagentaAddressForm.vue?7fae7631